export interface WawiData {
  kArtikel: number;
  kKategorie: number;
}

export interface AppConfig {
  wawiData: WawiData;
  basePath: string;
  external: boolean;
}

// eslint-disable-next-line prefer-destructuring, no-underscore-dangle
export const appConfig: AppConfig = (window as any).__APP_CONFIG;
